export default __webpack_public_path__ + "static/media/error.8922c970.png";